import {inlineError} from '@s-ui/decorators'
import {Service} from '@s-ui/domain'
/**
 * @implements Service
 */
export class SaveNavigationDataAdsService extends Service {
  /**
   * @constructor
   * @param {Object} deps
   * @param {Object} deps.config
   */
  constructor({config, saveNavigationDataSearchService}) {
    super()

    this._config = config
    this._service = saveNavigationDataSearchService
  }

  /**
   * @return {Promise<Object, Error>} list of searches
   */
  @inlineError
  async execute(navigationDataRequestValueObject) {
    return this._service
      .execute(navigationDataRequestValueObject)
      .then(([saveNavigationDataError, saveNavigationDataResponse]) => {
        if (saveNavigationDataError) return Promise.reject(saveNavigationDataError)
        return saveNavigationDataResponse
      })
  }
}
